
import React, { useEffect, useRef, useState  } from "react";
import { Autocomplete, GoogleMap, useJsApiLoader, Marker, Polygon  } from "@react-google-maps/api";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css';
import axios from 'axios';
import { Button } from 'react-bootstrap';
import logoMain from '../img/inmoapp_logo.png';
import { RotatingLines } from 'react-loader-spinner';
import CurrencyFormat from 'react-currency-format';
import wpp_png from "../img/wpp.png";
import Navbar from '../components/Navbar.jsx';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import { verifyToken } from '../utils/auth'; // Import the token verification function
import CustomNavbar from '../components/CustomNavbar.jsx'; // Import the Navbar component
import BuyCredits from '../components/BuyCreditsModal.js';
import PDF from '../components/TasacionPDF.js';
import '@fortawesome/fontawesome-free/css/all.min.css'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faCar, faRuler, faCogs, faCalendarAlt, faPhone, faEnvelope, faQuestionCircle, faHandshake, faMapMarkerAlt, faBuilding, faHouseUser, faHome as faHomeIcon } from '@fortawesome/free-solid-svg-icons';
import { apiBaseUrl, url } from '../config.js';



const libraries = ['places','geometry'];

function Vendor() {
  

  const navigate = useNavigate(); // Initialize navigate

  const { isLoaded, loadError } = useJsApiLoader({
		googleMapsApiKey: 'AIzaSyD9E7iaceHctltR_c_xL8dXbQo1OoFfMw8',
		libraries
	})

  // URL is now automatically configured based on environment

  function request_wpp(){
    fetch(`${url}/api/request_wpp_tasacionesya`).then(function (response) {
}).catch(function (err) {
});
}

  const [marker, setMarker] = useState({ lat: -34.6037345, lng: -58.3841453 });
  const [markers, setMarkers] = useState([]);
  const [coordsArray, setCoordsArray] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false); // Initialize state for authentication
  const [address, setAddress] = useState();
  const [addressD, setAddressD] = useState();
  const [zone, setZone] = useState("");
  const [operation, setOperation] = useState("venta");
  const [property, setProperty] = useState("departamento");
  const [amb, setAmb] = useState(1);
  const [garage, setGarage] = useState(0);
  const [sc, setSc] = useState(0);
  const [st, setSt] = useState(0);
  const [sd, setSd] = useState(0);
  const [sterre, setSterreno] = useState(0);
  const [condition, setCondition] = useState("Estrenar");
  const [antiguedad, setAntiguedad] = useState(1);
  const [barbecue, setBarbecue] = useState(false);
  const [pool, setPool] = useState(false);
  const [sum, setSum] = useState(false);
  const [email, setEmail] = useState();
  const [phone, setPhone] = useState();
  const [valorProp, setValorProp] = useState(0);
  const [valorPropUno, setValorPropUno] = useState(0);
  const [valorPropDos, setValorPropDos] = useState(0);
  const [gotPrice, setGotPrice] = useState(false);
  const [loadingPrice, setLoadingPrice] = useState(false);
  const [user, setUser] = useState('');
  const [modalC, setModalC] = useState(true);
  const [logedIn, setLogIn] = useState(false);
  const [credits, setCredits] = useState(null);
  const [username, setUsername] = useState(0);
  const [userLname, setUserLname] = useState(0);
  const [userType, setUserType] = useState(0);
  const [showBuyCredits, setShowBuyCredits] = useState(false);
  const [valuationType, setValuationType] = useState("simple"); // Added state for valuation type
  const [motive, setMotive] = useState("Personal"); // Added state for valuation motive


  const handleShowBuyCredits = () => setShowBuyCredits(true);
  const handleCloseBuyCredits = () => setShowBuyCredits(false);

  const handleBuyCredits = () => {
    // Implement the logic to handle credit purchase
    //alert(`Purchased ${pack.credits} credits for $${pack.price}`);
    //handleCloseBuyCredits();
    handleShowBuyCredits();
  };

  const a = async () => {
    const res = await axios.get("https://api.ipify.org/?format=json");
    setUser(res.data.ip);
  };

  useEffect(() => {
    a();
  }, []);

  useEffect(() => {
    const checkAuth = async () => {
      const authenticated = await verifyToken(); // Await the promise
      if (!authenticated) {
        navigate('/'); // Redirect to the main page if not authenticated
      } else {
        setIsAuthenticated(true);
      }
    };

    checkAuth();
  }, [navigate]);

  useEffect(() => {
    // Clear results when operation changes
    setGotPrice(false);
    setValorProp(0);
    setValorPropUno(0);
    setValorPropDos(0);
  }, [operation]);

  const checkAuthAndFetchCredits = async () => {
    try {
      // Check authentication
      const authenticated = await verifyToken();
      if (!authenticated) {
        navigate('/'); // Redirect to login page if not authenticated
      } else {
        setIsAuthenticated(true);

        // Fetch credits if authenticated
        const fetchCredits = async () => {
          try {
            const response = await axios.post('https://tasacionesya.com:8099/api/get_credits', {}, {
              headers: {
                'Authorization': `Bearer ${localStorage.getItem('userToken')}` // Pass the token in the Authorization header
              }
            });

            if (response.status === 200) {
              setCredits(response.data.credits); // Set the credits state
              if(response.data.credits == 0){ //&& credits != null){
                handleShowBuyCredits();
              }
            } else {
              // Handle specific errors based on status codes or response data
            }
          } catch (error) {
            // Handle the error accordingly
          }
        };

        await fetchCredits(); // Call fetchCredits after authentication
      }
    } catch (error) {
      navigate('/'); // Redirect to login page on error
    }
  };
  useEffect(() => {
    checkAuthAndFetchCredits();
  }, [navigate]);

  useEffect(() => {
    const checkGetUser = async () => {
      try {
        // Check authentication
        const authenticated = await verifyToken();
        if (!authenticated) {
          navigate('/'); // Redirect to login page if not authenticated
        } else {
          setIsAuthenticated(true);

          // Fetch credits if authenticated
          const getUser = async () => {
            try {
              const response = await axios.post('https://tasacionesya.com:8099/api/get_user', {}, {
                headers: {
                  'Authorization': `Bearer ${localStorage.getItem('userToken')}` // Pass the token in the Authorization header
                }
              });

              if (response.status === 200) {
                setUsername(response.data.username); 
                setUserLname(response.data.userLname);
                setUserType(response.data.userType);
              } else {
                // Handle specific errors based on status codes or response data
              }
            } catch (error) {
              // Handle the error accordingly
            }
          };

          await getUser(); // Call fetchCredits after authentication
        }
      } catch (error) {
        navigate('/'); // Redirect to login page on error
      }
    };

    checkGetUser();
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('userToken'); // Remove the token from local storage
    setIsAuthenticated(false); // Update state to reflect that the user is no longer authenticated
    navigate('/'); // Redirect to the main page or login page
  };

  const handleChange = (event,num) => {

    const inputValue = event.target.value;

    if(num=="amb"){
      if (/^\d*$/.test(inputValue)) {
        setAmb(inputValue);
      }
    }else if(num=="garage"){
      if (/^\d*$/.test(inputValue)) {
        setGarage(inputValue);
      }
    }else if(num=="sc"){
      if (/^\d*$/.test(inputValue)) {
        setSc(inputValue);
      }
    }else if(num=="st"){
      if (/^\d*$/.test(inputValue)) {
        setSt(inputValue);
      }
    }else if(num=="sd"){
      if (/^\d*$/.test(inputValue)) {
        setSd(inputValue);
      }
    }else if(num=="sterre"){
      if (/^\d*$/.test(inputValue)) {
        setSterreno(inputValue);
      }
    }else if(num=="antiguedad"){
      if (/^\d*$/.test(inputValue)) {
        setAntiguedad(inputValue);
      }
    }
    

    // Check if the input value is a valid integer
    
  };

  const get_price = () => {
    setLoadingPrice(true); // Set loading state to true at the start
  
    axios({
        method: 'POST',
        url: `${url}/api/get_price_vendor`,
        data: {
            address,
            addressD,
            zone_c: zone,
            operation,
            property,
            amb,
            garage,
            sc,
            st,
            sd,
            sterre,
            condition,
            antiguedad,
            barbecue,
            pool,
            sum,
            user_i: user,
            valuationType: valuationType, // Pass valuationType
            motive: motive // Pass motive
        },
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('userToken')}` // Pass the token in the Authorization header
        }
    })
    .then(res => {
        const { data } = res;

        // Handle different types of responses based on server response
        if (data.error) {
            switch (data.error) {
                case "err1":
                    setGotPrice(false);
                    alert("Por el momento no cubrimos la zona ingresada. Le estaremos enviando su valuacion una vez que la zona esté cargada. Gracias.");
                    break;
                case "err2":
                    alert("Por favor comuníquese con info@tasacionesya.com si desea continuar usando el servicio.");
                    break;
                case "No tiene créditos disponibles":
                    alert("No tiene más créditos.");
                    setGotPrice(false);
                    setModalC(true);
                    break;
                default:
                    alert("Hubo un error.");
            }
        } else {
            // Handle successful response
            if(operation=='alquiler'){
              setGotPrice(true);
              setValorProp(data.valor);
              setValorPropUno(data.averagePriceARS);
              setValorPropDos(data.averagePriceUSD);
              checkAuthAndFetchCredits();
            }else{
              setGotPrice(true);
              setValorProp(data.valor);
              setValorPropUno(data.valorPropUno);
              setValorPropDos(data.valorPropDos);
              checkAuthAndFetchCredits();
            }
        }

        // Scroll to bottom if price was successfully retrieved
        if (gotPrice) {
            scrollToBottom();
        }

        // Reset loading state
        setLoadingPrice(false);
    })
    .catch(error => {
        alert("Hubo un error. Por favor revise los datos ingresados.");
        setLoadingPrice(false);
    });
};

  

const send = (a) => {
  axios({
    method:'POST',
    url: 'https://tasacionesya.com:8099/api/send_a',
    data:{
      address: a
    }
}).then(res =>  {
}).catch(error => {
});
}

useEffect(() => {
  if(gotPrice){
    scrollToBottom();
  }
},[valorProp])

const scrollToBottom = () => {
  const element = document.getElementById("result");
  element.scrollIntoView();
}

/*
const onMapClick = (e) => {
  setMarkers((current) => [
      ...current,
      {
        lat: e.latLng.lat(),
        lng: e.latLng.lng()
      }
    ]);
    setCoordsArray(coordsArray+"{ lat: "+e.latLng.lat()+", lng: "+e.latLng.lng()+"},");
  };
  */


	const mapRef = useRef();
	const autocompleteRef = useRef();

  const stylesForm1 = `
    .form-container {
      padding: 20px;
      border-radius: 8px;
      color: white;
    }
    .form-label {
      font-weight: bold;
      padding: 10px;
      color: white;
      display: flex;
      align-items: center;
    }
    .form-label i {
      padding-right: 12px;
    }
    .form-control {
      transition: border-color 0.3s ease, box-shadow 0.3s ease;
    }
    .form-control:focus {
      border-color: #007bff;
      box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.25);
    }
    .form-group1 {
      margin-bottom: 1rem;
    }
    .form-group1.hidden {
      display: none;
    }
  `;

	const containerStyle = {
        width: "95%",
        height: "auto",
        margin:"auto",
        paddingTop: "10px",
        paddingRight:"0px",
        borderRadius:"20px",
        marginTop:"8%"
    }
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const mapContainerStyle = {
    //width: '95%',
    width: isMobile ? '100%' : '95%',
    height: isMobile ? '50vh' : '100vh',
    margin: 'auto',
    paddingTop: '10px',
    paddingRight: '0px',
    borderRadius: '20px',
    marginTop: '8%'
  };

	const inputStyle = {
		boxSizing: 'border-box',
		border: '1px solid transparent',
		width: '240px',
		height: '38px',
		padding: '0 12px',
		borderRadius: '3px',
		boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
		fontSize: '14px',
		outline: 'none',
		textOverflow: 'ellipses',
		position: 'absolute',
		right: '8%',
		top: '11px',
		marginLeft: '-120px'
	}

    const center = {
        lat: 28.626137,
        lng: 79.821603,
    }

	const onLoadMap = (map) => {
		mapRef.current = map
	}

	const onLoadAutocomplete = (autocomplete) => {
		autocompleteRef.current = autocomplete
	}

  const checkArea = (zone) => {
  }

  const TasarBtn = () => {
    if(!loadingPrice){
      return(
        <div style={{color:'white'}}>Valuar</div>
      )
    }else{
      return(
        <div><RotatingLines
        visible={true}
        height="45"
        width="45"
        color="grey"
        strokeWidth="5"
        animationDuration="0.75"
        ariaLabel="rotating-lines-loading"
        wrapperStyle={{}}
        wrapperClass=""
        /></div>
      )
    }
  }

	const handlePlaceChanged = async ()  => {
		const { geometry, formatted_address, results } = await autocompleteRef.current.getPlace();
    var zone = await JSON.stringify(JSON.stringify(autocompleteRef.current.getPlace().address_components));

    setZone(zone);
    setAddressD(formatted_address);
    send(formatted_address);
		const bounds = new window.google.maps.LatLngBounds();
		if (geometry.viewport) {
			bounds.union(geometry.viewport);
		} else {
			bounds.extend(geometry.location);
		}
		mapRef.current.fitBounds(bounds);
    setMarker(geometry.location);
    setAddress(geometry.location);
  }

  const containsLoc = [];

  return (
    <>
      <CustomNavbar isAuthenticated={isAuthenticated} handleLogout={handleLogout} username={username} amount={credits} onBuyCredits={handleShowBuyCredits} usertype={userType}/>
      <BuyCredits show={showBuyCredits} onHide={handleCloseBuyCredits} />
      
      <div className="App">
        {/* Hero Section */}
        <div style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          padding: '60px 20px',
          textAlign: 'center',
          color: 'white',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.1"%3E%3Ccircle cx="30" cy="30" r="2"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
            opacity: 0.3
          }}></div>
          
          <div style={{ position: 'relative', zIndex: 1 }}>
            <h1 style={{
              fontSize: '3.5rem',
              fontWeight: '700',
              marginBottom: '20px',
              textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
            }}>
              TasacionesYa
            </h1>
            <p style={{
              fontSize: '1.3rem',
              marginBottom: '30px',
              opacity: 0.9
            }}>
              Valuación profesional de propiedades en Argentina
            </p>
            
            {/* Quick Stats */}
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '40px',
              flexWrap: 'wrap'
            }}>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '2rem', fontWeight: 'bold' }}>100K+</div>
                <div style={{ fontSize: '0.9rem', opacity: 0.8 }}>Valuaciones</div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '40px 20px'
        }}>
          
          {/* Map Section */}
          <div style={{
            background: 'white',
            borderRadius: '16px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
            padding: '30px',
            marginBottom: '30px'
          }}>
            <h2 style={{
              fontSize: '1.8rem',
              fontWeight: '600',
              marginBottom: '20px',
              color: '#333'
            }}>
              📍 Ubicación de la Propiedad
            </h2>
            
            {/* Search Input - Outside Map */}
            <div style={{
              marginBottom: '20px'
            }}>
              <label style={{
                display: 'block',
                fontSize: '1rem',
                fontWeight: '600',
                marginBottom: '8px',
                color: '#555'
              }}>
                🔍 Buscar dirección
              </label>
              {isLoaded && (
                <Autocomplete 
                  onLoad={onLoadAutocomplete} 
                  onPlaceChanged={handlePlaceChanged}
                >
                  <div style={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    <input
                      type="text"
                      placeholder="Ingrese la dirección de la propiedad..."
                      style={{
                        width: '100%',
                        padding: '16px 20px 16px 50px',
                        borderRadius: '12px',
                        border: '2px solid #e1e5e9',
                        fontSize: '1rem',
                        background: 'white',
                        outline: 'none',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                        cursor: 'text'
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#667eea';
                        e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.25)';
                        e.target.style.transform = 'translateY(-2px)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = '#e1e5e9';
                        e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                        e.target.style.transform = 'translateY(0)';
                      }}
                      onMouseEnter={(e) => {
                        if (document.activeElement !== e.target) {
                          e.target.style.borderColor = '#667eea';
                          e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.15)';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (document.activeElement !== e.target) {
                          e.target.style.borderColor = '#e1e5e9';
                          e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                        }
                      }}
                    />
                    <div style={{
                      position: 'absolute',
                      left: '16px',
                      color: '#667eea',
                      fontSize: '1.2rem',
                      pointerEvents: 'none'
                    }}>
                      📍
                    </div>
                  </div>
                </Autocomplete>
              )}
            </div>
            
            <div style={{
              height: '400px',
              borderRadius: '12px',
              overflow: 'hidden',
              border: '2px solid #e1e5e9'
            }}>
              {!isLoaded ? (
                <div style={{
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: '#f8f9fa'
                }}>
                  <RotatingLines width="50" strokeColor="#667eea" />
                </div>
              ) : (
                <GoogleMap
                  mapContainerStyle={{ height: '100%', width: '100%' }}
                  center={marker}
                  zoom={15}
                  onLoad={onLoadMap}
                >
                  <Marker position={marker} />
                  {markers.map((marker, index) => (
                    <Marker
                      key={index}
                      position={{
                        lat: marker.lat,
                        lng: marker.lng
                      }}
                    />
                  ))}
                </GoogleMap>
              )}
            </div>
          </div>

          {/* Valuation Form */}
          <div 
            data-section="detalles"
            style={{
              background: 'white',
              borderRadius: '16px',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
              padding: '30px',
              marginBottom: '30px'
            }}
          >
            <h2 style={{
              fontSize: '1.8rem',
              fontWeight: '600',
              marginBottom: '30px',
              color: '#333'
            }}>
              🏠 Detalles de la Propiedad
            </h2>

            {/* Operation & Property Type */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '20px',
              marginBottom: '30px'
            }}>
              {/* Operation Type */}
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '1rem',
                  fontWeight: '600',
                  marginBottom: '10px',
                  color: '#555'
                }}>
                  Tipo de Operación
                </label>
                <div style={{
                  display: 'flex',
                  gap: '10px'
                }}>
                  <button
                    onClick={() => setOperation('venta')}
                    style={{
                      flex: 1,
                      padding: '12px 20px',
                      borderRadius: '8px',
                      border: 'none',
                      background: operation === 'venta' ? '#667eea' : '#f8f9fa',
                      color: operation === 'venta' ? 'white' : '#555',
                      fontWeight: '600',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    Venta
                  </button>
                  {/* Rental option temporarily hidden until MercadoLibre API issue is resolved */}
                  {/* <button
                    onClick={() => setOperation('alquiler')}
                    style={{
                      flex: 1,
                      padding: '12px 20px',
                      borderRadius: '8px',
                      border: 'none',
                      background: operation === 'alquiler' ? '#667eea' : '#f8f9fa',
                      color: operation === 'alquiler' ? 'white' : '#555',
                      fontWeight: '600',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    Alquiler
                  </button> */}
                </div>
              </div>

              {/* Property Type */}
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '1rem',
                  fontWeight: '600',
                  marginBottom: '10px',
                  color: '#555'
                }}>
                  Tipo de Propiedad
                </label>
                <div style={{
                  display: 'flex',
                  gap: '10px'
                }}>
                  <button
                    onClick={() => setProperty('departamento')}
                    style={{
                      flex: 1,
                      padding: '12px 20px',
                      borderRadius: '8px',
                      border: 'none',
                      background: property === 'departamento' ? '#667eea' : '#f8f9fa',
                      color: property === 'departamento' ? 'white' : '#555',
                      fontWeight: '600',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    Departamento
                  </button>
                  <button
                    onClick={() => {
                      setProperty('casa');
                      setValuationType("advanced");
                    }}
                    style={{
                      flex: 1,
                      padding: '12px 20px',
                      borderRadius: '8px',
                      border: 'none',
                      background: property === 'casa' ? '#667eea' : '#f8f9fa',
                      color: property === 'casa' ? 'white' : '#555',
                      fontWeight: '600',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    Casa
                  </button>
                </div>
              </div>
            </div>

            {/* Valuation Type */}
            <div style={{
              background: '#f8f9fa',
              padding: '20px',
              borderRadius: '12px',
              marginBottom: '30px'
            }}>
              <label style={{
                display: 'block',
                fontSize: '1rem',
                fontWeight: '600',
                marginBottom: '15px',
                color: '#555'
              }}>
                Tipo de Valuación
              </label>
              <div style={{
                display: 'flex',
                gap: '15px'
              }}>
                <button
                  onClick={() => {
                    setValuationType("simple");
                    setAmb(1);
                  }}
                  style={{
                    flex: 1,
                    padding: '15px 20px',
                    borderRadius: '8px',
                    border: 'none',
                    background: valuationType === "simple" ? '#28a745' : '#e9ecef',
                    color: valuationType === "simple" ? 'white' : '#495057',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                >
                  Valuación Simple
                </button>
                <button
                  onClick={() => setValuationType("advanced")}
                  style={{
                    flex: 1,
                    padding: '15px 20px',
                    borderRadius: '8px',
                    border: 'none',
                    background: valuationType === "advanced" ? '#28a745' : '#e9ecef',
                    color: valuationType === "advanced" ? 'white' : '#495057',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                >
                  Valuación Avanzada
                </button>
              </div>
            </div>

            {/* Form Fields */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '20px'
            }}>
              {/* Phone Number */}
              <div style={{
                gridColumn: '1 / -1',
                background: 'linear-gradient(135deg, #667eea, #764ba2)',
                padding: '25px',
                borderRadius: '12px',
                color: 'white'
              }}>
                <label style={{
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '1.1rem',
                  fontWeight: '600',
                  marginBottom: '15px'
                }}>
                  📱 WhatsApp para recibir el resultado
                </label>
                <input
                  type="tel"
                  placeholder="📱 11-2222-3333"
                  value={phone || ''}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                  style={{
                    width: '100%',
                    padding: '15px',
                    fontSize: '1rem',
                    borderRadius: '8px',
                    border: 'none',
                    outline: 'none',
                    background: 'white',
                    color: '#333'
                  }}
                />
              </div>

              {/* Simple Valuation Fields */}
              {valuationType === "simple" ? (
                <>
                  <div>
                    <label style={{
                      display: 'block',
                      fontSize: '1rem',
                      fontWeight: '600',
                      marginBottom: '8px',
                      color: '#555'
                    }}>
                      🏠 Ambientes
                    </label>
                    <select
                      value={amb}
                      onChange={(e) => setAmb(parseInt(e.target.value))}
                      style={{
                        width: '100%',
                        padding: '12px',
                        borderRadius: '8px',
                        border: '1px solid #ddd',
                        fontSize: '1rem',
                        background: 'white'
                      }}
                    >
                      <option value={1}>1</option>
                      <option value={2}>2</option>
                      <option value={3}>3</option>
                      <option value={4}>4</option>
                      <option value={5}>5</option>
                    </select>
                  </div>

                  <div>
                    <label style={{
                      display: 'block',
                      fontSize: '1rem',
                      fontWeight: '600',
                      marginBottom: '8px',
                      color: '#555'
                    }}>
                      🚗 Cochera/s
                    </label>
                    <input
                      type="number"
                      value={garage || ''}
                      onChange={(e) => handleChange(e, "garage")}
                      style={{
                        width: '100%',
                        padding: '12px',
                        borderRadius: '8px',
                        border: '1px solid #ddd',
                        fontSize: '1rem'
                      }}
                    />
                  </div>

                  <div>
                    <label style={{
                      display: 'block',
                      fontSize: '1rem',
                      fontWeight: '600',
                      marginBottom: '8px',
                      color: '#555'
                    }}>
                      🔧 Estado
                    </label>
                    <select
                      value={condition}
                      onChange={(e) => setCondition(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px',
                        borderRadius: '8px',
                        border: '1px solid #ddd',
                        fontSize: '1rem',
                        background: 'white'
                      }}
                    >
                      <option value="Estrenar">Estrenar</option>
                      <option value="Muy bueno">Muy bueno</option>
                      <option value="Bueno">Bueno</option>
                      <option value="Regular">Regular</option>
                      <option value="Malo">Malo</option>
                    </select>
                  </div>

                  <div>
                    <label style={{
                      display: 'block',
                      fontSize: '1rem',
                      fontWeight: '600',
                      marginBottom: '8px',
                      color: '#555'
                    }}>
                      📅 Antigüedad (años)
                    </label>
                    <input
                      type="number"
                      value={antiguedad}
                      onChange={(e) => handleChange(e, "antiguedad")}
                      style={{
                        width: '100%',
                        padding: '12px',
                        borderRadius: '8px',
                        border: '1px solid #ddd',
                        fontSize: '1rem'
                      }}
                    />
                  </div>
                </>
              ) : (
                // Advanced valuation fields
                <>
                  <div>
                    <label style={{
                      display: 'block',
                      fontSize: '1rem',
                      fontWeight: '600',
                      marginBottom: '8px',
                      color: '#555'
                    }}>
                      🏠 Ambientes
                    </label>
                    <input
                      type="number"
                      value={amb}
                      onChange={(e) => handleChange(e, "amb")}
                      style={{
                        width: '100%',
                        padding: '12px',
                        borderRadius: '8px',
                        border: '1px solid #ddd',
                        fontSize: '1rem'
                      }}
                    />
                  </div>

                  <div>
                    <label style={{
                      display: 'block',
                      fontSize: '1rem',
                      fontWeight: '600',
                      marginBottom: '8px',
                      color: '#555'
                    }}>
                      🚗 Cochera/s (cantidad)
                    </label>
                    <input
                      type="number"
                      value={garage || ''}
                      onChange={(e) => handleChange(e, "garage")}
                      style={{
                        width: '100%',
                        padding: '12px',
                        borderRadius: '8px',
                        border: '1px solid #ddd',
                        fontSize: '1rem'
                      }}
                    />
                  </div>

                  <div>
                    <label style={{
                      display: 'block',
                      fontSize: '1rem',
                      fontWeight: '600',
                      marginBottom: '8px',
                      color: '#555'
                    }}>
                      📏 Superficie Cubierta (m²)
                    </label>
                    <input
                      type="number"
                      value={sc || ''}
                      onChange={(e) => handleChange(e, "sc")}
                      style={{
                        width: '100%',
                        padding: '12px',
                        borderRadius: '8px',
                        border: '1px solid #ddd',
                        fontSize: '1rem'
                      }}
                    />
                  </div>

                  {/* Superficie Total - Only show for houses */}
                  {property === 'casa' && (
                    <div>
                      <label style={{
                        display: 'block',
                        fontSize: '1rem',
                        fontWeight: '600',
                        marginBottom: '8px',
                        color: '#555'
                      }}>
                        📐 Superficie Total (m²)
                      </label>
                      <input
                        type="number"
                        value={st || ''}
                        onChange={(e) => handleChange(e, "st")}
                        style={{
                          width: '100%',
                          padding: '12px',
                          borderRadius: '8px',
                          border: '1px solid #ddd',
                          fontSize: '1rem'
                        }}
                      />
                    </div>
                  )}

                  {/* Superficie Descubierta - Only show for houses */}
                  {property === 'casa' && (
                    <div>
                      <label style={{
                        display: 'block',
                        fontSize: '1rem',
                        fontWeight: '600',
                        marginBottom: '8px',
                        color: '#555'
                      }}>
                        🌳 Superficie Descubierta (m²)
                      </label>
                      <input
                        type="number"
                        value={sd || ''}
                        onChange={(e) => handleChange(e, "sd")}
                        style={{
                          width: '100%',
                          padding: '12px',
                          borderRadius: '8px',
                          border: '1px solid #ddd',
                          fontSize: '1rem'
                        }}
                      />
                    </div>
                  )}

                  {/* Superficie Terreno - Only show for houses */}
                  {property === 'casa' && (
                    <div>
                      <label style={{
                        display: 'block',
                        fontSize: '1rem',
                        fontWeight: '600',
                        marginBottom: '8px',
                        color: '#555'
                      }}>
                        🏞️ Superficie Terreno (m²)
                      </label>
                      <input
                        type="number"
                        value={sterre || ''}
                        onChange={(e) => handleChange(e, "sterre")}
                        style={{
                          width: '100%',
                          padding: '12px',
                          borderRadius: '8px',
                          border: '1px solid #ddd',
                          fontSize: '1rem'
                        }}
                      />
                    </div>
                  )}

                  {/* Superficie Semicubierta - Only show for apartments */}
                  {property === 'departamento' && (
                    <div>
                      <label style={{
                        display: 'block',
                        fontSize: '1rem',
                        fontWeight: '600',
                        marginBottom: '8px',
                        color: '#555'
                      }}>
                        🏢 Superficie Semicubierta (m²)
                      </label>
                      <input
                        type="number"
                        value={st || ''}
                        onChange={(e) => handleChange(e, "st")}
                        style={{
                          width: '100%',
                          padding: '12px',
                          borderRadius: '8px',
                          border: '1px solid #ddd',
                          fontSize: '1rem'
                        }}
                      />
                      <small style={{ 
                        fontSize: '0.8rem', 
                        color: '#6c757d', 
                        marginTop: '4px', 
                        display: 'block' 
                      }}>
                        Balcones, terrazas, espacios cubiertos parcialmente
                      </small>
                    </div>
                  )}

                  {/* Superficie Descubierta - Show for both apartments and houses */}
                  <div>
                    <label style={{
                      display: 'block',
                      fontSize: '1rem',
                      fontWeight: '600',
                      marginBottom: '8px',
                      color: '#555'
                    }}>
                      🌳 Superficie Descubierta (m²)
                    </label>
                    <input
                      type="number"
                      value={sd || ''}
                      onChange={(e) => handleChange(e, "sd")}
                      style={{
                        width: '100%',
                        padding: '12px',
                        borderRadius: '8px',
                        border: '1px solid #ddd',
                        fontSize: '1rem'
                      }}
                    />
                    <small style={{ 
                      fontSize: '0.8rem', 
                      color: '#6c757d', 
                      marginTop: '4px', 
                      display: 'block' 
                    }}>
                      {property === 'departamento' ? 'Terraza abierta, balcón sin techo, espacios al aire libre' : 'Patio, jardín, espacios al aire libre'}
                    </small>
                  </div>

                  <div>
                    <label style={{
                      display: 'block',
                      fontSize: '1rem',
                      fontWeight: '600',
                      marginBottom: '8px',
                      color: '#555'
                    }}>
                      🔧 Estado
                    </label>
                    <select
                      value={condition}
                      onChange={(e) => setCondition(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px',
                        borderRadius: '8px',
                        border: '1px solid #ddd',
                        fontSize: '1rem',
                        background: 'white'
                      }}
                    >
                      <option value="Estrenar">Estrenar</option>
                      <option value="Muy bueno">Muy bueno</option>
                      <option value="Bueno">Bueno</option>
                      <option value="Regular">Regular</option>
                      <option value="Malo">Malo</option>
                      <option value="Restauracion">Restauración</option>
                      <option value="Demolicion">Demolición</option>
                    </select>
                  </div>

                  <div>
                    <label style={{
                      display: 'block',
                      fontSize: '1rem',
                      fontWeight: '600',
                      marginBottom: '8px',
                      color: '#555'
                    }}>
                      📅 Antigüedad (años)
                    </label>
                    <input
                      type="number"
                      value={antiguedad}
                      onChange={(e) => handleChange(e, "antiguedad")}
                      style={{
                        width: '100%',
                        padding: '12px',
                        borderRadius: '8px',
                        border: '1px solid #ddd',
                        fontSize: '1rem'
                      }}
                    />
                  </div>

                  <div>
                    <label style={{
                      display: 'block',
                      fontSize: '1rem',
                      fontWeight: '600',
                      marginBottom: '8px',
                      color: '#555'
                    }}>
                      ❓ ¿Motivo de valuación?
                    </label>
                    <select
                      value={motive || 'Personal'}
                      onChange={(e) => setMotive(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px',
                        borderRadius: '8px',
                        border: '1px solid #ddd',
                        fontSize: '1rem',
                        background: 'white'
                      }}
                    >
                      <option value="Personal">Personal</option>
                      <option value="Inmobiliaria">Inmobiliaria</option>
                      <option value="Escribania">Escribanía</option>
                      <option value="Comercial">Comercial</option>
                      <option value="Inversión">Inversión</option>
                    </select>
                  </div>

                  {/* Amenities */}
                  <div style={{ gridColumn: '1 / -1' }}>
                    <label style={{
                      display: 'block',
                      fontSize: '1rem',
                      fontWeight: '600',
                      marginBottom: '12px',
                      color: '#555'
                    }}>
                      🏊 Amenities
                    </label>
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                      gap: '15px'
                    }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                      }}>
                        <input
                          type="checkbox"
                          checked={barbecue}
                          onChange={(e) => setBarbecue(e.target.checked)}
                          style={{
                            width: '18px',
                            height: '18px'
                          }}
                        />
                        <label style={{ fontSize: '0.9rem', color: '#555' }}>
                          🍖 Parrilla
                        </label>
                      </div>
                      
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                      }}>
                        <input
                          type="checkbox"
                          checked={pool}
                          onChange={(e) => setPool(e.target.checked)}
                          style={{
                            width: '18px',
                            height: '18px'
                          }}
                        />
                        <label style={{ fontSize: '0.9rem', color: '#555' }}>
                          🏊 Piscina
                        </label>
                      </div>
                      
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                      }}>
                        <input
                          type="checkbox"
                          checked={sum}
                          onChange={(e) => setSum(e.target.checked)}
                          style={{
                            width: '18px',
                            height: '18px'
                          }}
                        />
                        <label style={{ fontSize: '0.9rem', color: '#555' }}>
                          🏖️ Quincho
                        </label>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>

            {/* Submit Button */}
            <div style={{
              marginTop: '30px',
              textAlign: 'center'
            }}>
              <button
                onClick={get_price}
                disabled={!address || loadingPrice}
                style={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '12px',
                  padding: '16px 40px',
                  fontSize: '1.1rem',
                  fontWeight: '600',
                  cursor: loadingPrice || !address ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 8px 25px rgba(102, 126, 234, 0.3)',
                  opacity: loadingPrice || !address ? 0.6 : 1
                }}
                onMouseEnter={(e) => {
                  if (!loadingPrice && address) {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 12px 35px rgba(102, 126, 234, 0.4)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!loadingPrice && address) {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.3)';
                  }
                }}
              >
                {loadingPrice ? (
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <RotatingLines width="20" strokeColor="white" style={{ marginRight: '10px' }} />
                    Procesando...
                  </div>
                ) : (
                  <>
                    🏠 Valuar Propiedad
                  </>
                )}
              </button>
            </div>
          </div>

          {/* Results Section */}
          {gotPrice && (
            <div style={{
              background: 'white',
              borderRadius: '16px',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
              padding: '30px',
              marginBottom: '30px',
              textAlign: 'center'
            }}>
              <h3 style={{
                fontSize: '1.8rem',
                fontWeight: '600',
                marginBottom: '20px',
                color: '#333'
              }}>
                🏠 Resultado de la Valuación
              </h3>
              <p style={{ color: '#555', marginBottom: '20px' }}>{addressD}</p>
              
              {operation === 'alquiler' ? (
                <div>
                  <div style={{
                    fontSize: '2rem',
                    fontWeight: '700',
                    color: '#667eea',
                    margin: '10px 0'
                  }}>
                    AR$ {valorPropUno?.toLocaleString()}
                  </div>
                  <div style={{
                    fontSize: '1.5rem',
                    fontWeight: '600',
                    color: '#28a745',
                    margin: '10px 0'
                  }}>
                    USD {valorPropDos?.toLocaleString()}
                  </div>
                </div>
              ) : (
                <div>
                  <div style={{
                    fontSize: '2rem',
                    fontWeight: '700',
                    color: '#667eea',
                    margin: '10px 0'
                  }}>
                    Entre USD {valorPropUno?.toLocaleString()} y USD {valorPropDos?.toLocaleString()}
                  </div>
                  <PDF
                    name={username}
                    lastName={userLname}
                    address={addressD}
                    msc={st}
                    md={sd}
                    mc={sc}
                    garage={garage}
                    antiguedad={antiguedad}
                    condicion={condition}
                    price1={valorPropUno}
                    price2={valorPropDos}
                    credits={credits}
                    setCreds={setCredits}
                  />
                </div>
              )}
            </div>
          )}

          {/* Footer */}
          <div style={{
            textAlign: 'center',
            padding: '30px',
            color: '#555',
            fontSize: '14px'
          }}>
            <p>
              <strong>info@tasacionesya.com</strong> - 
              <a href="/terminos-y-condiciones" style={{
                color: '#667eea',
                textDecoration: 'none',
                fontWeight: '600'
              }}> Términos y Condiciones</a>
            </p>
            <p>Copyright © tasacionesya.com 2024</p>
          </div>
        </div>
      </div>
    </>
  );

}

export default Vendor;
